import api from "@/lib/axiosConfig";
import type { Data } from "@measured/puck";
import { BASE } from "@/api/cms-puck/client";

/** Forme visuelle d'un bloc pour la vignette wireframe. */
export type PreviewShape =
  | "image"
  | "title"
  | "text"
  | "grid"
  | "quote"
  | "form"
  | "cta"
  | "button"
  | "line";

/** Set (collection) auquel appartient un modèle. */
export interface TemplateSet {
  /** Clé stable du set (ex. « basic »). */
  key: string;
  /** Clé GlobalI18n du titre du set (résolue via `cmsNew`). */
  titleKey: string;
  /** Repli FR du titre du set. */
  titleFr: string;
}

/** Résumé d'un modèle de la bibliothèque (renvoyé par `GET /templates`). */
export interface PuckTemplateSummary {
  key: string;
  name: string;
  description: string;
  /** Set (collection) auquel appartient le modèle. */
  set: TemplateSet;
  tags: string[];
  components: string[];
  /** Silhouette des blocs (ordre du seed) → vignette. */
  preview: PreviewShape[];
}

/**
 * Liste des modèles de pages disponibles (set système), localisée via `lang`
 * (nom / description / tags / composants). `lang` absente → français.
 */
export async function listTemplates(
  lang?: string,
): Promise<PuckTemplateSummary[]> {
  const { data } = await api.get<PuckTemplateSummary[]>(`${BASE}/templates`, {
    params: lang ? { lang } : undefined,
  });
  return data;
}

/**
 * Données de rendu d'un modèle pour l'aperçu réel : layout Puck neutre + contenu
 * type de la langue par défaut (à hydrater côté BO avant `<Render>`).
 */
export async function getTemplatePreview(
  key: string,
  lang?: string,
): Promise<{ data: Data; strings: Record<string, string> }> {
  const { data } = await api.get<{ data: Data; strings: Record<string, string> }>(
    `${BASE}/templates/${encodeURIComponent(key)}/preview`,
    { params: lang ? { lang } : undefined },
  );
  return data;
}
